import { buildResourcefulRequests, buildSingularResourcefulRequests } from '@utils/requests'

export const resourcefulJointScenarioRequest = (jointScenarioId, resourceName) => {
  const basePath = `/api/joint_plans/${jointScenarioId}/${resourceName}`

  return buildResourcefulRequests(basePath)
}

export const singularResourcefulJointScenarioRequest = (jointScenarioId, resourceName) => {
  const basePath = `/api/joint_plans/${jointScenarioId}/${resourceName}`

  return buildSingularResourcefulRequests(basePath)
}
